module.exports = __webpack_public_path__ + "img/Nastia.6a9964c0.jpg";